<template>
    <div class="relative mt-auto">
        <div class="container mx-auto">
            <div class="flex items-center justify-between md:px-6 py-3">
                <div class="flex flex-wrap flex-1 items-center justify-between space-y-2">
                    <div>
                        <p class="text-sm text-gray-700">
                            Showing
                            {{ ' ' }}
                            <span class="font-medium">{{ props.pagination.from }}</span>
                            {{ ' ' }}
                            to
                            {{ ' ' }}
                            <span class="font-medium">{{ props.pagination.to }}</span>
                            <template v-if="props.pagination.total">
                                {{ ' ' }}
                                of
                                {{ ' ' }}
                                <span class="font-medium">{{ props.pagination.total }}</span>
                                {{ ' ' }}
                                results
                            </template>
                        </p>
                    </div>
                    <div v-if="props.pagination.links">
                        <nav class="isolate inline-flex flex-wrap -space-x-px rounded-md shadow-sm" aria-label="Pagination">
                            <Link :href="props.pagination.prev_page_url ?? ''"
                                  :preserveState="true"
                                  class="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20">
                                <span class="sr-only">Previous</span>
                                <PhCaretLeft weight="bold" class="h-4 w-4" aria-hidden="true"/>
                            </Link>
                            <template v-for="(link, key) in props.pagination.links.slice(1, -1)" :key="key">
                                <span v-if="link.url === null"
                                      class="hidden md:inline-flex relative items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700">
                                    {{ link.label }}
                                </span>
                                <Link v-else-if="link.active" :href="link.url" aria-current="page"
                                      :preserveState="true"
                                      class="inline-flex relative z-10 items-center border border-indigo-500 bg-indigo-50 px-4 py-2 text-sm font-medium text-indigo-600 focus:z-20">
                                    {{ link.label }}
                                </Link>
                                <Link v-else :href="link.url"
                                      :preserveState="true"
                                      class="hidden md:inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20">
                                    {{ link.label }}
                                </Link>
                            </template>
                            <Link :href="props.pagination.next_page_url ?? ''"
                                  :preserveState="true"
                                  class="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20">
                                <span class="sr-only">Next</span>
                                <PhCaretRight weight="bold" class="h-4 w-4" aria-hidden="true"/>
                            </Link>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {Link} from '@inertiajs/vue3';
import {PhCaretLeft, PhCaretRight} from '@phosphor-icons/vue';

const props = defineProps({
    pagination: Object,
});

</script>
